"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _createPaginationItems["default"];
  }
});

var _createPaginationItems = _interopRequireDefault(require("./createPaginationItems"));


//////////////////
// WEBPACK FOOTER
// ../~/semantic-ui-react/dist/commonjs/lib/createPaginationItems/index.js
// module id = 2211
// module chunks = 1